module.exports = __webpack_public_path__ + "img/camioncitosalida.c061b54d.png";